// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-graph-wrapper {
  flex: 1 1 0;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphApp/styles.css","webpack://./services/frontend/app/components/Graph/GraphApp/styles.css"],"names":[],"mappings":"AADA;ECEE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".canvas-graph-wrapper {\n  overflow: hidden;\n  flex: 1 1 0;\n}\n",".canvas-graph-wrapper {\n  flex: 1 1 0;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
